
<!--
~ VNCtask : VNCtask – the easy to use Task Management & To-Do List application. Stay organized. Anytime! Anywhere!
~ Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
~
~ This program is free software: you can redistribute it and/or modify
~ it under the terms of the GNU Affero General Public License as published by
~ the Free Software Foundation, version 3 of the License.
~
~ This program is distributed in the hope that it will be useful,
~ but WITHOUT ANY WARRANTY; without even the implied warranty of
~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
~ GNU Affero General Public License for more details.
~
~ You should have received a copy of the GNU Affero General Public License
~ along with this program. Look for COPYING file in the top folder.
~ If not, see http://www.gnu.org/licenses/.
-->

<div class="vp-select-tags-dialog" id="taskSelectTagsDialog">
  <div class="task__dialog-header">
    <div class="mobile-back-button">
      <button matButton (click)="close()">
        <mat-icon class="disable-select">close</mat-icon>
      </button>
    </div>
    <div class="header_lbl disable-select">
      {{'SELECT_TAGS' | translate}}
    </div>
    <div class="desktop-close-button">
      <button matButton (click)="close()">
        <mat-icon class="disable-select">close</mat-icon>
      </button>
    </div>
  </div>
  <div class="task__dialog-body task__dialog-body--pad">

    <mat-list role="list">
      <mat-radio-group (change)="typeChanged()" class="select-tags-radio-group" [(ngModel)]="selectedTagType">
        <mat-list-item role="listitem">
          <mat-radio-button class="radio-button-style" id="input_none" [value]="TagType.NONE">{{ getTagTypeObject(TagType.NONE).translation_key | translate }}</mat-radio-button>
        </mat-list-item>
        <mat-list-item role="listitem">
          <mat-radio-button class="radio-button-style" id="input_all_tags" [value]="TagType.ALL_TAGS">{{ getTagTypeObject(TagType.ALL_TAGS).translation_key | translate }}</mat-radio-button>
        </mat-list-item>
        <mat-list-item role="listitem">
          <mat-radio-button class="radio-button-style" id="input_selected" [value]="TagType.SELECTED">{{ getTagTypeObject(TagType.SELECTED).translation_key | translate }}</mat-radio-button>
        </mat-list-item>
      </mat-radio-group>
    </mat-list>



    @if (selectedTagType === TagType.SELECTED) {
      <div class="selected-tags">
        <div id="select-tags-list-dialog" class="option-list">
          <mat-form-field class="filter-search-textfield">
            <mat-label>{{ 'FIND_THE_TAG' | translate }}</mat-label>
            <input matInput [(ngModel)]="searchText">
          </mat-form-field>
          <mat-list role="list" [class.changed]="changed">
            @for (tag of tagList  | vpTaskProjectSearch : searchText; track tag; let i = $index) {
              <mat-list-item role="listitem" class="tag-list-item"
                [class.selected]="i == selectedIndex">
                <div class="list-lable">
                  <span>{{tag.name}}</span>
                </div>
                <div class="list-action">
                  <vnc-checkbox [isRoundCheckBox]="true" (change)="tagSelected($event , tag)" [checked]="isTagSelected(tag)"></vnc-checkbox>
                </div>
              </mat-list-item>
            }
          </mat-list>
        </div>
      </div>
    }
  </div>
  <div class="task__dialog-footer">
    <div class="desktop-footer">
      <button matButton (click)="close()">
        {{ 'CANCEL' | translate }}
      </button>
      <button matButton [disabled]="!changed" (click)="saveTags()">
        {{ 'SAVE' | translate }}
      </button>
    </div>
    @if (changed) {
      <div class="mobile-footer">
        <div class="title">
          {{ 'SETTINGS_UPDATED_APPLY_CHANGES' | translate }}
        </div>
        <div class="save_footer_btn">
          <button matButton (click)="saveTags()">
            <mat-icon>check</mat-icon>
          </button>
        </div>
      </div>
    }
  </div>
</div>
